// Assignment order types
export const ROUND_ROBIN = 'round_robin';
export const BALANCED = 'balanced';
export const ROTATION_UNTIL_REPLY = 'rotation_until_reply';

// Assignment priority types
export const EARLIEST_CREATED = 'earliest_created';
export const LONGEST_WAITING = 'longest_waiting';

// Default values for fair distribution
export const DEFAULT_FAIR_DISTRIBUTION_LIMIT = 100;
export const DEFAULT_FAIR_DISTRIBUTION_WINDOW = 3600;

// Default values for rotation (timeout in minutes for UI)
export const DEFAULT_ROTATION_TIMEOUT = 5;
export const DEFAULT_MAX_ROTATIONS = 10;

// Default age threshold for excluding stale unassigned conversations (7 days)
export const DEFAULT_EXCLUDE_OLDER_THAN_HOURS = 168;

// Options groupings
export const OPTIONS = {
  ORDER: [ROUND_ROBIN, BALANCED, ROTATION_UNTIL_REPLY],
  PRIORITY: [EARLIEST_CREATED, LONGEST_WAITING],
};
